import { axios } from '@/utils/request'

// Download template API: https://web.inxchile.com/api/web/webpublic/statistics/downloadApmFile
export function downloadTemplate() {
  return axios({
    url: '/statistics/downloadApmFile',
    method: 'POST',
    responseType: 'blob',
  })
}

// Upload API
// https://web.inxchile.com/api/web/webpublic/statistics/uploadApmFile
// File type parameter name: file
export function uploadFile(data) {
  return axios({
    url: '/statistics/uploadApmFile',
    method: 'POST',
    data,
    responseType: 'blob',
    downloadFile: 'true',
  })
}
